import { useEffect, useState } from 'react';
import { useResize } from '../hooks/useResize';
import { useLocation } from 'react-router-dom';
import { useScroll } from '../hooks/useScroll';
import Aos from 'aos';

function Header(props) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [activeIdx, setActiveIdx] = useState(0);
  const size = useResize();
  const location = useLocation();
  const [currentMenu, setCurrentMenu] = useState('HOME');
  const [isScrollHeader, setIsScrollHeader] = useState(false);
  const { scrollY } = useScroll();
  const menuItems = [
    { id: 1, name: 'HOME', link: '/' },
    { id: 2, name: 'PRODUCT', link: '/product' },
    { id: 3, name: 'R&D', link: '/rnd' },
    { id: 4, name: 'CONTACT US', link: '/contact' },
  ];
  useEffect(() => {
    Aos.init();
  });
  useEffect(() => {
    if (size.width < 1025) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [size]);

  useEffect(() => {
    setActiveIdx(props.activeIdx);
    if (props.activeIdx > 0) {
      setIsScrollHeader(true);
    } else {
      setIsScrollHeader(false);
    }
  }, [props]);

  useEffect(() => {
    const visualHeight = document.getElementById('visual').offsetHeight;
    const headerHeight = document.getElementById('header').offsetHeight;

    if (scrollY > visualHeight - headerHeight) {
      setIsScrollHeader(true);
    } else {
      setIsScrollHeader(false);
    }
    // Aos.init();
  }, [scrollY]);

  const onMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header
      id='header'
      className={`fixed z-50 flex justify-end w-full h-auto px-6 py-5 ease-in duration-700  ${
        isScrollHeader ? 'bg-white border-b-[2px] border-[#F2F2F2]' : ''
      }`}
    >
      <h1 className='absolute z-30 w-24 h-auto top-5 left-6'>
        <a href='/'>
          {isMenuOpen || isScrollHeader ? (
            <img
              className='w-full h-full'
              src={`${process.env.PUBLIC_URL}/assets/images/common/img_logo_black.svg`}
              alt=''
            />
          ) : (
            <img
              className='w-full h-full'
              src={`${process.env.PUBLIC_URL}/assets/images/common/img_logo_white.svg`}
              alt=''
            />
          )}
        </a>
      </h1>
      {isMobile && (
        <button className='relative z-10 w-6 h-6' onClick={onMenuToggle}>
          {isMenuOpen ? (
            <img
              className='w-full h-full'
              src={`${process.env.PUBLIC_URL}/assets/images/common/ico_menu_close.svg`}
              alt=''
            />
          ) : isScrollHeader ? (
            <img
              className='w-full h-full'
              src={`${process.env.PUBLIC_URL}/assets/images/common/ico_menu_black.svg`}
              alt=''
            />
          ) : (
            <img
              className='w-full h-full'
              src={`${process.env.PUBLIC_URL}/assets/images/common/ico_menu.svg`}
              alt=''
            />
          )}
        </button>
      )}

      <div
        className={`${
          isMobile && isMenuOpen
            ? 'fixed top-0 left-0 w-full h-full bg-[url("/public/assets/images/common/bg_menu_open.png")] bg-cover'
            : !isMobile
            ? 'w-full'
            : ''
        }`}
      >
        <div className='flex items-center justify-center w-full h-full text-center'>
          <nav
            className={`${
              !isMobile ? 'justify-center' : isMenuOpen ? '' : 'hidden'
            }`}
          >
            <ul className={`${isMobile ? 'block' : 'flex'}`}>
              {menuItems.map((item, idx) => (
                <li
                  key={idx.toString()}
                  className={!isMobile && idx > 0 ? 'md:ml-28' : 'ml-0'}
                >
                  <a
                    href={item.link}
                    className={`${
                      location.pathname === item.link
                        ? 'border-black border-b-[2px] lg:border-white lg:border-b-[1px]'
                        : ''
                    } ${
                      isScrollHeader ? 'lg:text-black' : 'lg:text-white'
                    } inline-block text-[1.3rem] font-bold md:font-semibold text-black  md:text-[1.13rem] leading-5 py-1 mb-6 lg:mb-0`}
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
